<template>
    <div>
        <div class="card">
            <div v-if="group.user_agreement" class="flex justify-between items-center">
                <div class="flex items-center w-1/2">
                    <div class="icon-circle bg-neutral-lightest">
                        <font-awesome-icon :icon="['far','file-alt']" />
                    </div>
                    <div class="ml-md">
                        <a
                            :href="route('admin.sales-projects.groups.download-user-agreement', [project, group])"
                            style="word-break: break-all"
                        >
                            {{ group.user_agreement.file_name }}
                        </a>
                    </div>
                </div>
                <div>
                    <button
                        class="btn btn-sm is-ghost"
                        @click="$modal.show('upload-user-agreement')"
                    >
                        Ladda upp nyttjandeavtal
                    </button>
                </div>
            </div>
            <div v-else class="flex items-center">
                <div>
                    <span class="icon-circle bg-neutral-lightest">
                        <font-awesome-icon :icon="['far','file-alt']" />
                    </span>
                    <span class="ml-md">Nyttjandeavtal saknas</span>
                </div>
                <div class="ml-auto">
                    <button
                        class="btn btn-sm is-primary"
                        @click="$modal.show('upload-user-agreement')"
                    >
                        Ladda upp nyttjandeavtal
                    </button>
                </div>
            </div>
        </div>

        <adaptive-form-modal
            name="upload-user-agreement"
            primary-button-text="Ladda upp"
            primary-button-class="is-primary"
            title="Ladda upp nyttjandeavtal"
            method="patch"
            :files="true"
            :action="route('api.sales-projects.groups.user-agreement.update', [project, group])"
            :callback="handleUploadCallback"
        >
            <div class="form-group">
                <label>
                    <input
                        type="file"
                        name="file"
                        class="form-input"
                    >
                </label>
            </div>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                required: true,
                type: Object,
            },
            initialGroup: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                group: this.initialGroup,
            };
        },
        methods: {
            handleUploadCallback({ data }) {
                flash_success('Fil uppladdad!');
                this.group = data.group;
                this.$modal.hide('upload-user-agreement');
            },
        },
    };
</script>
